import { differenceInMinutes } from 'date-fns';
export const hasDurationPassed = (startDate, endDate, durationInMinutes) => {
    const durationFromStartDateToEndDateInMinutes = differenceInMinutes(endDate, startDate);
    return durationFromStartDateToEndDateInMinutes > durationInMinutes;
};
